import React from "react";

const iconSizeClasses = {
  sm: "w-2.5 h-2.5",
  md: "w-3 h-3",
  lg: "w-3.5 h-3.5",
};

const ToggleKnobIcon = ({ checked, className }) => (
  <svg
    viewBox="0 0 12 12"
    className={className}
    aria-hidden="true"
    fill="none"
  >
    {checked ? (
      <path
        d="M2.2 6.3 4.8 8.8 9.8 3.2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ) : (
      <path
        d="M3 3l6 6M9 3l-6 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    )}
  </svg>
);

// Modern Toggle Switch
export const ToggleSwitch = ({
  checked,
  onChange,
  disabled = false,
  size = "md",
  className = "",
}) => {
  const sizeClasses = {
    sm: "w-10 h-6",
    md: "w-12 h-6",
    lg: "w-14 h-7",
  };

  const knobSizeClasses = {
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
  };

  const handleClick = (e) => {
    e.stopPropagation();
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      className={`
        ${
          sizeClasses[size]
        } rounded-full transition-all duration-200 flex items-center
        ${checked ? "bg-brand-charcoal justify-end" : "bg-brand-mist justify-start"}
        ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
        ${className}
      `}
    >
      <div
        className={`
        ${knobSizeClasses[size]} bg-white rounded-full shadow-md
        transform transition-transform duration-200 mx-0.5
        flex items-center justify-center
        ${checked ? "text-brand-charcoal" : "text-brand-mist"}
      `}
      >
        <ToggleKnobIcon
          checked={checked}
          className={iconSizeClasses[size]}
        />
      </div>
    </button>
  );
};

export default ToggleSwitch;
